// src/breadcrumbMap.js
const breadcrumbMap = {
  "/": ["Dashboard"],
  "/homedashboard": ["Dashboard"],
  "/adminchat": ["Admin Chat"],
  "/AdminchattingPage": ["Admin Chatting Page"],
  "/create_user": ["User", "Create User"],
  "/all_users": ["User", "All Users List"],
  "/inactive_users": ["User", "Inactive Users List"],
  "/active_users": ["User", "Active Users List"],
  "/user_wallet_balance": ["User Wallet", "User Wallet Balance"],

  "/main_market_list": ["Game", "Main Market List"],
  "/king_jack_port_market_list": ["Game", "King Jack Port Market List"],
  "/king_starline_market_list": ["Game", "King Starline Market List"],
  "/point_user_wallet_balance": [
    "Point Management",
    "Point User Wallet Balance",
  ],


    "/main_market_game_load": ["Game Load", "Main Market Game Load"],
  "/king_jackport_game_load": ["Game Load", "King Jack Port Market Game Load"],
  "/king_starline_game_load": ["Game Load", "King Starline Market Game Load"],

  "/user/login-user-list": ["User", "Login User List"],

  "/withdrawal-pending": ["Withdrawal", "Pending"],
  "/withdrawal-complete": ["Withdrawal", "Complete"],
  "/withdrawal-reject": ["Withdrawal", "Reject"],
  "/withdrawal_report_datewise": ["Date Wise Withdrawal Report", "Date Wise Withdrawal Report"],

  "/bank_account_pending": ["BankAccountPending", "Bank Account Pending"],
  "/bank_account_complete": ["BankAccountComplete", "Bank Account Complete"],
  "/bank_account_reject": ["BankAccountReject", "Bank Account Reject"],


  "/deposite_pending": ["Deposit", "Pending Deposit"],
  "/deposite_complete": ["Deposit", "Completed Deposit"],
  "/deposite_reject": ["Deposit", "Rejected Deposit"],
  "/deposite_report_datewise": ["Date Wise Deposit Report", "Date Wise Deposit Report"],



  "/point_management_add_point": ["Point Management", "Add Point"],
  "/point_management_deduct_point": ["Point Management", "Deduct Point"],
  "/admin_add_point_history": ["Point Management", "Admin Add Point History"],
  "/auto_point_add_history": ["Point Management", "Auto Point History"],

  "/bet_history_pending": ["BetHistory", "Pending Bet Histories"],
  "/bet_history_success": ["BetHistorySuccess", "Success Bet Histories"],
  "/game_load_bet_loss_lists": ["Game Load Bet Loss Lists", "Game Load Bet Loss Lists"],
  "/game_report_datewise": ["Game Report Date Wise Lists", "Game Report Date Wise Lists"],

  "/declare_main": ["Declare Result", "Declare Main Market Result"],
  "/declare_king_jack": [
    "Declare Result",
    "Declare King Jack Port Market Result",
  ],
  "/declare_king_starline": [
    "Declare King StraLine Market",
    "Declare King Starline Market Result",
  ],

  "/running_main_market_lists": ["Main Market ", "Running Main Market "],

  "/running_king_jack_port_lists": [
    "Running Jack Port Market ",
    "Running King Jack Port Market ",
  ],

  "/running_king_starline_lists": [
    "Running King StarLine Market",
    "Running King StarLine Market",
  ],

  // "/starline-market-list-n": ["Running Game", "Starline Market"],

  "/update_rates": ["Game Rates", "Update All Game Rates"],

  "/upload-old-main-market-list": ["Upload Old Result", "Main Market"],
  "/upload-old-delhi-market-list": ["Upload Old Result", "Delhi Market"],
  "/upload-old-starline-market-list-n": [
    "Upload Old Result",
    "Starline Market",
  ],

  // "/bidding_report": ["Reports", "User Bid Analysis"],
  // "/user_bidding_report": ["Reports", "User Bid Report"],
  // "/user_full_bidding_report": ["Reports", "Full Bidding Details"],
  // "/user_transactions_history": ["Reports", "Transaction History"],
  // "/user_winner_history": ["Reports", "Winner History"],
  // "/user_result_analysis_history": ["Reports", "Result Analysis"],

  // "/banners/index": ["Banners"],

  "/notice_management": ["Notice Management"],
  "/config": ["Settings", "Application Settings"],
  "/pay_in_gateway_settings": ["PayIn Gateway Settings"],
  "/video_lists": ["Video Lists", "Video Lists"],
  "/idea_submit_lists": ["Idea Submit Lists", "Idea Submit Lists"],

  // "/notification/notification-list": ["Notification", "Send Notification"],
  //"/user/inactive-user-list": ["User", "Inactive Users List"],
  "/create_roles": ["RolesAndPermissions", "Create Roles & Permissions"],
  "/all_roles": ["CreatedRolesAndPermissions", "Created Roles & Permissions"],
  "/active_roles": ["ActiveRolesAndPermissions", "Active Roles & Permissions"],
  "/inactive_roles": [
    "InactiveRolesAndPermissions",
    "Inactive Roles & Permissions",
  ],
};

export default breadcrumbMap;
